import styled from 'styled-components';

export const Content = styled.div``;
